(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    if (!window.fullSlideLinkHandlerInitialized) {
    window.fullSlideLinkHandlerInitialized = true;

    const interactiveSelector =
      'a, button, input, select, textarea, label, summary, [role="button"], [role="link"]';

    const openFullSlideLink = (slide) => {
      const url = slide.dataset.fullSlideLink;

      if (!url || window.Shopify?.designMode) return;

      window.location.assign(url);
    };

    document.addEventListener('click', (event) => {
      const slide = event.target.closest('slideshow-slide[data-full-slide-link]');

      if (!slide) return;

      const interactiveElement = event.target.closest(interactiveSelector);

      if (interactiveElement && interactiveElement !== slide) return;

      openFullSlideLink(slide);
    });

    document.addEventListener('keydown', (event) => {
      const slide = event.target.closest('slideshow-slide[data-full-slide-link]');

      if (!slide || event.target !== slide) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      openFullSlideLink(slide);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
